import http from '../../src/utils/http';
export default {
  namespaced: true,
  // 储存数据
  state: {
    config: {}, // APP整体配置
  },
  mutations: {
    setConfig(state, payload) {
      for (let i in payload) {
        for (let j in state.config) {
          if (i === j) {
            state.config[j] = payload[i];
          }
        }
      }
    }
  },
  // 操作数据
  actions: {
    // WanlShop 初始化，检测
    async init({
      state,
      dispatch,
      rootState
    }) {
      http.get("/wanlshop/addctl/getconfs", {}).then(res => {
          state.config = res;
          localStorage.setItem("jx:common", JSON.stringify(res))
        },
        err => {

        })
    }
  }
};



//////////////////
// WEBPACK FOOTER
// ./store/modules/common.js
// module id = null
// module chunks = 